import { api } from './client';

/**
 * Docs → story-order preview (#1242). Read only.
 * Accept writes through createCustom + setFramework, not through this call.
 */
export const docsStoryOrderApi = {
  preview: (projectId, { batchIds = [] } = {}) => (
    api.post(`/projects/${projectId}/docs-story-order/preview`, {
      batch_ids: batchIds,
    })
  ),
};
